import { Injectable } from '@angular/core';
import { VariableEnvironnementUserService } from './variable-environnement-user.service';

@Injectable()
export class VariableEnvironnementUserOfflineService extends VariableEnvironnementUserService {
    constructor(
    ) {
        super();
    }
}